import React from "react";
export default function WorkFlow_1_Icon(fillColor) {
  return (
    <div style={{ marginRight: "8px" }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill={fillColor.color} />
        <path
          d="M11.5137 17H12.7441V7.13574H11.5205L8.89551 9.02246V10.3213L11.4043 8.50293H11.5137V17Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
